import { logger } from "../logger/logger"

export const PUNCTUATIONS = [",", ".", "!", "?"]
export const isPunctuation = (x: string)=> PUNCTUATIONS.includes(x)

export function clampIndex(index: number, length: number): number {
  return Math.min(Math.max(index, 0), length - 1)
}

export function isQuestionWord(x: Word): x is QuestionWord {
  // SAFETY: type guard checks for isVisible property
  return (x as QuestionWord).isVisible !== undefined
}

// eslint-disable anti-slop/no-runtime-typeof -- boundary type guards
export const isString = (x: unknown): x is string=> typeof x === "string"
export const isNumber = (x: unknown): x is number=> typeof x === "number"
export const isBoolean = (x: unknown): x is boolean=> typeof x === "boolean"
export const isObject = (x: unknown): x is object=>
  typeof x === "object" && x !== null
export const isFunction = (x: unknown): x is (...args: unknown[])=> void=>
  typeof x === "function"
// eslint-enable anti-slop/no-runtime-typeof

export function precondition(
  condition: unknown,
  message?: string,
  options?: { callback?: ()=> void; notify?: boolean; skipThrow?: boolean },
): asserts condition {
  if (!condition) {
    if (options?.notify) {
      logger({
        input: new Error(message ?? "Precondition failed"),
        level: "error",
      })
      if (options?.skipThrow) return
    }
    if (options?.callback) {
      options.callback()
    }
    throw new Error(message ?? "Precondition failed")
  }
}

export function toDecimal(num: number, charsAfterDecimalPoint = 2) {
  return Number(parseFloat(String(num)).toFixed(charsAfterDecimalPoint))
}

const NON_FULLSCREEN_ROUTES: string[] = []

export function isFullscreenRoute(route: string) {
  return !NON_FULLSCREEN_ROUTES.includes(route)
}
export function mergeDeep<T>(...objects): T {
  return objects.reduce((prev, obj)=> {
    Object.keys(obj).forEach(key=> {
      const pVal = prev[key]
      const oVal = obj[key]

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal)
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal)
      } else {
        prev[key] = oVal
      }
    })

    return prev
  }, {})
}

export const Utils = {
  string: {
    getWords: (x: string)=> x.split(" ").filter(Boolean),
  },
}
